import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const actionService = {
    createAction,
    getActionCollection,
    editAction
};

function createAction(data) {
    const header = authHeader();
    header['Content-Type'] = 'application/merge-patch+json';
    const requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(data)
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/actions`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function editAction(data) {
    const header = authHeader();
    header['Content-Type'] = 'application/merge-patch+json';
    const requestOptions = {
        method: 'PATCH',
        headers: header,
        body: JSON.stringify(data)
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/actions`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

async function getActionCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let allActions = [];
    let currentPage = 1;
    let totalPages;

    do {
        const response = await fetch(`${process.env.VUE_APP_API_SERVER}/api/actions?page=${currentPage}`, requestOptions);
        const data = await handleResponse(response);

        if (currentPage === 1) {
            allActions = data
        } else {
            allActions['hydra:member'] = allActions['hydra:member'].concat(data['hydra:member']);
        }

        totalPages = Math.ceil(data['hydra:totalItems'] / 30);
        currentPage++;
    } while (currentPage <= totalPages);

    return allActions;
}